import React from 'react';
import { Shield, Zap, Users, Award, Building2, Code, Megaphone, HeartPulse } from 'lucide-react';
export function AboutSection() {
  const highlights = [{
    icon: Shield,
    label: 'Defense Systems',
    color: 'text-blue-600'
  }, {
    icon: Zap,
    label: 'Real-Time Payments',
    color: 'text-emerald-600'
  }, {
    icon: Building2,
    label: 'Enterprise Architecture',
    color: 'text-purple-600'
  }, {
    icon: Code,
    label: 'Fintech Innovation',
    color: 'text-orange-600'
  }, {
    icon: Users,
    label: 'Leadership',
    color: 'text-cyan-600'
  }, {
    icon: Award,
    label: 'Security Expert',
    color: 'text-rose-600'
  }, {
    icon: Megaphone,
    label: 'Mar-Tech',
    color: 'text-amber-600'
  }, {
    icon: HeartPulse,
    label: 'Med-Tech',
    color: 'text-teal-600'
  }];
  return <section id="about" className="py-24 bg-[#0d1321] px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-1" data-mp="1joxn37478vnx">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-2" data-mp="xjul3rwizk3b">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgb(255 255 255) 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-3" data-mp="xkm84ec249hz"></div>
      </div>

      <div className="max-w-5xl mx-auto relative" data-id="element-4" data-mp="1bj3ots3jolqe">
        <div className="text-center mb-16" data-id="element-5" data-mp="1ghf2yf0vhief">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-6" data-mp="1gh592gcpir3g">
            About Arthur
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full" data-id="element-7" data-mp="12jyruq7mt0gc"></div>
        </div>

        {/* Expertise highlights */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-8" data-mp="3n7v6a5obey9h">
          {highlights.map((item, index) => <div key={index} className="flex flex-col items-center gap-2 p-4 bg-white/5 rounded-xl border border-white/10 hover:border-cyan-500/50 hover:bg-white/10 transition-all group backdrop-blur-sm" data-id="element-9" data-mp="3raht1s64pszt" data-mpi={index}>
              <div className={`${item.color} group-hover:scale-110 transition-transform`} data-id="element-10" data-mp="1o16chfz5wfgo">
                <item.icon className="h-8 w-8" data-id="element-11" data-mp="1j2mo78x3irl5" />
              </div>
              <span className="text-xs font-medium text-slate-400 text-center group-hover:text-cyan-300 transition-colors" data-id="element-12" data-mp="1j08up4i2dnfp">
                {item.label}
              </span>
            </div>)}
        </div>

        <div className="prose prose-lg prose-slate mx-auto" data-id="element-13" data-mp="152250bn9qtr4">
          <div className="text-slate-400 leading-relaxed space-y-6" data-id="element-14" data-mp="152k9twnzygan">
            <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 p-8 rounded-2xl border border-cyan-500/20 shadow-sm backdrop-blur-sm glow-cyan" data-id="element-15" data-mp="104iu9lps4z3x">
              <p className="text-xl font-medium text-slate-300 mb-0" data-id="element-16" data-mp="2uhi38vznmv28">
                Arthur Miller is a technology executive and enterprise architect
                with deep experience building secure, large-scale financial
                infrastructure. His career has focused on modernizing financial
                systems, designing high-availability distributed platforms, and
                implementing security architectures for regulated industries.
              </p>
            </div>

            <p data-id="element-17" data-mp="2jzoa6maiay6o">
              Arthur previously served as a lead engineer working on
              applications supporting the U.S. Defense Information Systems
              Agency (DISA) contracted through Tasc (Enginity) and later became
              an enterprise architect and engineering leader within the
              financial services industry. He played a key architectural role in
              the development and scaling of Zelle® and Real-Time Payments
              (RTP) infrastructure, helping financial institutions adopt modern
              real-time payment systems at a national scale.
            </p>

            <p data-id="element-18" data-mp="1m6x21e5ecpq7">
              He later served as Chief Technology Officer of a white-label
              fintech company focused on Buy-Now-Pay-Later lending solutions,
              where he led the development of lending infrastructure designed to
              integrate directly into financial institutions' digital banking
              ecosystems.
            </p>

            <p data-id="element-19" data-mp="254hramc2pqbc">
              Arthur has spent much of his career advising financial
              institutions and fintech organizations on enterprise architecture,
              secure integration design, cloud infrastructure, distributed
              systems, and regulatory-grade security frameworks. His experience
              across defense systems, national payment networks, and fintech
              lending platforms uniquely positions him to lead FiQIS in building
              the next generation of secure financial infrastructure.
            </p>

            <div className="bg-white/5 p-6 rounded-xl border-l-4 border-cyan-400 backdrop-blur-sm" data-id="element-20" data-mp="2ixz83zddkoxo">
              <p className="mb-0 font-medium text-slate-300" data-id="element-21" data-mp="32fv7exxrzmnp">
                At FiQIS, Arthur leads company strategy, platform architecture,
                security design, and regulatory alignment as the organization
                builds infrastructure that enables financial institutions to
                modernize safely while maintaining ownership of the customer
                relationship.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}